// ABOUTME: Callback page for fitness device OAuth connections (Garmin, Polar, Suunto, etc.)
// ABOUTME: Redirects to settings page after successful gadget connection

import { useNavigate } from "react-router"
import { useEffect } from "react"
import { SETTINGS_ROUTES } from "@shared/constants/navigation"

const GadgetConnectCallback = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(SETTINGS_ROUTES.profile, { state: { isGadgetConnected: true } })
  }, [navigate])

  return null
}

export default GadgetConnectCallback
